import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImgViewModal from '../../../../views/app/common/modal/ImgViewModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class ModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({ name: 'imgViewModal', value: false });
  };

  render() {
    return <ImgViewModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.imgViewModal.isOpen,
    data: state.app.imgViewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ModalContainer));
